import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const element = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The build embeds the exact initial HTML. Hydration preserves the DOM and
// attaches form/menu interactions instead of wiping the pre-rendered page.
if (container.hasChildNodes()) {
  hydrateRoot(container, element);
} else {
  createRoot(container).render(element);
}
